import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, mapProps, branch, renderComponent } from 'recompose'
import { IconButton } from 'react-toolbox/lib/button'
import * as R from 'ramda'

import { Table, TableHead, TableRow, TableCell } from 'react-toolbox/lib/table'

const getTableRows = (source, tableHeadContent) => {
  return source.map((src, i) => 
  <TableRow key={i}>
    {Object.keys(tableHeadContent).map((key, i) => {
      return <TableCell key={`${key}${i}`}>{(src && src[key]) ? src[key] : ""}</TableCell>
    })}
  </TableRow>)
}

const getTableHead = (tableHeadContent) => {
  return (<TableHead>{Object.values(tableHeadContent).map((val) => val)}</TableHead>)
}

const TableComponent = ({styles, source, tableHeadContent, ...rest}) => {
  return (
    <div className="tableContainer" style={{overflow: 'auto'}}>
      <Table
          multiSelectable={false}
          selectable={false}
          theme={styles}>
          {getTableHead(tableHeadContent)}
          {getTableRows(source, tableHeadContent)}
      </Table>
    </div>)
}

export default TableComponent
